import checkModule from '@/components/checkLayout/module/checkModule'
import checkHandleModule from '@/components/checkLayout/module/checkHandleModule'
import checkInfoModule from '@/components/checkLayout/module/checkInfoModule'
import infoTable from '@/components/module/infoTable'
import compartModule from '@/components/checkLayout/module/compartModule'

export default {
  data () {
    return {
      // 页面参数id
      snaId: '',
      // 审批结果对象
      checkFromData: {
        checkResult: '通过',
        remark: ''
      },
      // 通过id获取的审批信息对象
      checkDataInfo: {}
    }
  },
  components: {
    checkModule,
    checkHandleModule,
    checkInfoModule,
    infoTable,
    compartModule
  },
  watch: {
    // 监听当前审批是否审批过
    checkDataInfo () {
      const { checkDataInfo } = this
      if (this.isCheck(checkDataInfo)) {
        this.goCheckDetail(checkDataInfo)
      }
      return checkDataInfo
    }
  },
  created () {
    this.snaId = this.$route.query.bizId
  },
  methods: {
    /**
     * 审批参数格式化
     * @param checkform  审批结果
     */
    formatCheckParams (checkform = {}) {
      const { checkDataInfo } = this
      const auditType = checkform.checkResult === '通过'
      const {
        snaId
      } = this
      const targetObj = {
        auditType,
        bizId: checkDataInfo.id || snaId,
        bizRFId: checkDataInfo.approvalId,
        mark: checkform.remark,
        approvaState: Number(auditType),
        // bizUrl: data.approvalState,
        systemNomalApproval: {
          bizId: checkDataInfo.bizId,
          bizType: checkDataInfo.bizType,
          exPlain: '',
          id: checkDataInfo.id
        }
      }
      if (checkform.baddebtFlag) {
        const {
          commissionDeduction,
          companyCommitment
        } = checkform
        // 坏账审批
        Object.assign(targetObj, { commissionDeduction, companyCommitment })
      }
      return targetObj
    },
    /**
     * 判断审批页面数据是不是已经审批过
     * @param data 审批数据
     */

    isCheck (data) {
      return !!data.systemFlowRunAuditOrgVos || !!data.systemFlowRunAuditOrgVo
    },
    /**
     * 设置表格头部颜色
     * @param rowIndex
     * @returns {string}
     */
    tableHeader ({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    },
    /**
     * 返回结果是不是成功请求
     * @param res
     * @returns {boolean}
     */
    isSuccess (res) {
      return res.data.code === 200
    },
    /**
     * 判断是不是审批成功了 跳转详情
     * @param res 审批结果
     */
    goCheckDetail (res) {
      const { snaId, checkDetailName } = this
      if (this.isCheck(res) || this.isSuccess(res)) {
        this.$router.replace({
          name: checkDetailName,
          query: {
            bizId: snaId
          }
        })
      } else {
        this.$message.error(res.data.msg)
      }
    }
  }
}
